import React from 'react'
import { makeStyles } from '@mui/styles'

import { withModal } from 'utils/providers/ModalProvider'

import modals from 'constants/modals'

import { DialogButtons } from 'shared'

import { BaseDialog } from 'shared'

import {
  BaseModalComponentType,
  ModalNameToModalMap,
} from 'components/modals/types'
import { useAuth } from 'utils/providers/AuthProvider'
import { useIsMobile } from 'utils/hooks/useIsMobile'
import LogoutDrawer from './drawer'

const useStyles = makeStyles(() => {
  return {
    dialog: {
      '& .base-dialog-header': {
        marginBottom: 12,
        '& h2': {
          fontSize: '24px',
          fontWeight: '700',
          lineHeight: '24px',
        },
      },
    },
  }
})

const LogoutModal = ({
  isOpen,
  closeModal,
}: BaseModalComponentType & {
  payload: ModalNameToModalMap['logout']
}) => {
  const classes = useStyles()
  const { logout } = useAuth()
  const isMobile = useIsMobile()

  if (isMobile) {
    return <LogoutDrawer isOpen={isOpen} closeDrawer={closeModal} />
  }

  return (
    <BaseDialog
      open={isOpen}
      onClose={closeModal}
      title="Are you sure you want to log out?"
      className={classes.dialog}
    >
      <DialogButtons
        onCancel={closeModal}
        onSubmit={() => {
          closeModal()
          logout()
        }}
        submitTitle="Continue"
      />
    </BaseDialog>
  )
}

export default withModal(modals.logout)(LogoutModal)
